import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { VenueSummary } from "./staffApi";

/**
 * The venue in view, resolved once by [VenueShellLayout] from the `/v/:venueId` path segment against
 * the bootstrap query. Deep-linkable and multi-tab safe: two tabs on two venues each carry their own
 * context (and their own SSE subscription + query cache).
 */
export interface VenueScope {
  venueId: string;
  venue: VenueSummary;
}

const VenueCtx = createContext<VenueScope | null>(null);

export function VenueProvider({ value, children }: { value: VenueScope; children: ReactNode }) {
  return <VenueCtx.Provider value={value}>{children}</VenueCtx.Provider>;
}

/** The current venue scope. Throws if used outside a `/v/:venueId` shell (a programming error). */
export function useVenue(): VenueScope {
  const scope = useContext(VenueCtx);
  if (!scope) throw new Error("useVenue() must be used inside a VenueShellLayout");
  return scope;
}
